import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { Layout } from '../components/layout';
import { Home, ArrowLeft, Recycle } from 'lucide-react';
import { useSafeAnimation, useCanAnimate } from '../components/ui/SafeMotion';

export function NotFound() {
  // SSR-safe animation props
  const anim = useSafeAnimation(
    { opacity: 0, y: 20 },
    { opacity: 1, y: 0 }
  );
  const canAnimate = useCanAnimate();

  return (
    <Layout>
      <Helmet>
        <title>Page Not Found - Eco Enviro</title>
      </Helmet>

      <section className="min-h-[80vh] flex items-center justify-center bg-gradient-to-b from-eco-green-50 to-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={anim.initial}
            animate={anim.animate}
            className="max-w-lg mx-auto text-center"
          >
            {/* Icon - only animate rotation on client */}
            {canAnimate ? (
              <motion.div
                animate={{ rotate: [0, 360] }}
                transition={{ duration: 20, repeat: Infinity, ease: 'linear' }}
                className="w-32 h-32 bg-eco-green-100 rounded-full flex items-center justify-center mx-auto mb-8"
              >
                <Recycle className="w-16 h-16 text-eco-green-600" />
              </motion.div>
            ) : (
              <div className="w-32 h-32 bg-eco-green-100 rounded-full flex items-center justify-center mx-auto mb-8">
                <Recycle className="w-16 h-16 text-eco-green-600" />
              </div>
            )}

            {/* 404 */}
            <h1 className="text-8xl font-bold text-eco-green-200 mb-4">404</h1>
            
            <h2 className="text-2xl font-bold text-eco-green-900 mb-4">
              Page Not Found
            </h2>
            
            <p className="text-muted-foreground mb-8">
              Looks like this page has been recycled! Let's get you back on track.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/"
                className="px-6 py-3 bg-gradient-to-r from-eco-green-600 to-eco-green-700 text-white font-medium rounded-xl hover:from-eco-green-700 hover:to-eco-green-800 transition-all flex items-center justify-center gap-2"
              >
                <Home className="w-5 h-5" />
                Go Home
              </Link>
              <button
                onClick={() => window.history.back()}
                className="px-6 py-3 border border-eco-green-200 text-eco-green-700 font-medium rounded-xl hover:bg-eco-green-50 transition-colors flex items-center justify-center gap-2"
              >
                <ArrowLeft className="w-5 h-5" />
                Go Back
              </button>
            </div>
          </motion.div>
        </div>
      </section>
    </Layout>
  );
}
